/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-mate.chat-error-banner.description': '채팅 기록은 최대 30일간 저장됩니다.',
  'ai-mate.chat-error-banner.title': '새 채팅 시작',
  'ai-mate.chat-error.description': '<btn>채팅을 다시 로드</btn>해 보세요.',
  'ai-mate.chat-error.rate-limited-description': '최대 요청 수에 도달했습니다. 나중에 다시 시도하세요.',
  'ai-mate.chat-error.rate-limited-title': '요청이 너무 많음',
  'ai-mate.chat-error.rovo-inactive-description':
    '귀하의 사이트에서 Rovo가 활성화되지 않은 것 같습니다. <link>Rovo 설정</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo가 비활성화됨',
  'ai-mate.chat-error.title': '알 수 없는 문제가 발생했습니다',
  'ai-mate.chat-input.file-close-icon-label': '파일 제거',
  'ai-mate.chat-input.file-error-icon-label': '파일을 로드하는 동안 오류',
  'ai-mate.chat-view.chat-item.chat-delete-label': '삭제',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': '{conversationName}의 채팅 옵션',
  'ai-mate.chat-view.chat-item.chat-rename-label': '이름 변경',
  'ai-mate.common.ui.expandable-section.collapse': '접기',
  'ai-mate.common.ui.expandable-section.expand': '펼치기',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': '취소',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '삭제하려고 하는 대화가 존재하지 않습니다.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '삭제',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '"{name}" 대화를 삭제하시겠습니까?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '대화를 삭제하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    '이 대화를 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': '취소',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '편집하려는 채널이 존재하지 않습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '이름',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '대화를 편집하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '대화 편집',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '이름이 현재 이름과 같습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '저장',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, other {{results,number}개의 결과를 찾았습니다}}',
  'ai-mate.conversation-list-view.back-button.label': '뒤로',
  'ai-mate.conversation-list-view.close-chat-button.label': '채팅 닫기',
  'ai-mate.conversation-list-view.header-title': '채팅 기록',
  'ai-mate.conversation-list-view.new-chat-button.label': '새 채팅',
  'ai-mate.conversation-list-view.no-chat': '결과 없음',
  'ai-mate.conversation-list-view.search-input.placeholder': '채팅 검색',
  'ai-mate.expander.hide-details': '세부 정보 숨기기',
  'ai-mate.expander.show-details': '세부 정보 자세히 보기',
  'ai-mate.main-chat.close-chat-panel-button-label': '채팅 닫기',
  'ai-mate.main-chat.maximize-chat-button-label': '전체 화면',
  'ai-mate.main-chat.minimize-chat-button-label': '보기 복원',
  'ai-mate.main-chat.new-chat-button-label': '신규',
  'ai-mate.main-chat.new-chat-button-label-full-screen': '새 채팅',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': '보내기',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'AI에게 질문',
  'highlight-actions.rovo-chat-explain-option.text': '설명',
  'highlight-actions.rovo-chat-explain-prompt':
    '표현을 바꾸고 세부 정보를 추가하여 설명하되 아주 간단한 표현과 짧은 문장을 사용하고 원래 문구에서 사용된 기술 용어에 대해 예시나 정의를 제공해 줘.',
  'highlight-actions.rovo-chat-find-resources-option.text': '리소스 찾기',
  'highlight-actions.rovo-chat-find-resources-prompt':
    '조직 차원의 참조 자료 내에서만 이 진술을 뒷받침하는 리소스를 찾아 줘.',
  'highlight-actions.rovo-chat-give-examples-option.text': '예시 제공',
  'highlight-actions.rovo-chat-give-examples-prompt':
    '조직 차원의 리소스 또는 공개 참조 자료에서 이것의 예시를 제공해 줘. 제공할 리소스가 없으면 이것을 더 자세히 이해하는 데 도움이 되는 은유적인 예시를 제공해 줘.',
  'highlight-actions.rovo-chat-give-feedback-option.text': '피드백 보내기',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    '이 문구를 검토해서 피드백을 제공해 줘. 단어 선택, 문법, 구두점에 대한 설명을 제공해 줘. 긍정적이고 열정적인 표현을 유지하되 언제나 개선하거나 변경할 점을 하나 이상 제공해 줘.',
  'highlight-actions.rovo-chat-more-options.tooltip': '채팅 추천',
  'highlight-actions.rovo-chat-open-chat.tooltip': '채팅 열기',
  'highlight-actions.rovo-chat-summarize-option.text': '요약',
  'highlight-actions.rovo-chat-summarize-prompt':
    '요점을 강조 표시해 줘. 필수 정보에 집중하고 필요하지 않은 세부 정보를 제외해 줘. 간결한 개요를 하나의 단락으로 제공해 줘.',
  'highlight-actions.rovo-chat.button-text': '채팅',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': '채팅으로 질문',
  'highlight-actions.rovo-chat.placeholder-prompt': '이것에 대해 질문해 보세요.',
  'horizontal-scroll-container.scroll-left': '왼쪽으로 스크롤',
  'horizontal-scroll-container.scroll-right': '오른쪽으로 스크롤',
  'rovo-chat.deep-research-spotlight.description':
    '딥 리서치를 사용으로 설정하고 프롬프트를 입력하세요. Rovo는 계획을 만들고, 조사를 수행하며, 전체 보고서를 생성합니다.',
  'rovo-chat.deep-research-spotlight.dismiss': '해제',
  'rovo-chat.deep-research-spotlight.heading': 'Rovo의 딥 리서치 소개',
  'rovo-chat.file-upload-dropzone.drag-drop-message': '끌어서 놓아 컨텍스트 추가',
  'rovo-chat.message-file.icon-label': '파일',
};
